import { render, staticRenderFns } from "./ModelFive.vue?vue&type=template&id=95c759b4&scoped=true"
import script from "./ModelFive.vue?vue&type=script&lang=js"
export * from "./ModelFive.vue?vue&type=script&lang=js"
import style0 from "./ModelFive.vue?vue&type=style&index=0&id=95c759b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c759b4",
  null
  
)

export default component.exports